import Vue from 'vue'
import Vuex from 'vuex';
import user from './modules/user';
import janus from './modules/janus';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user, janus
    }
});


// WEBPACK FOOTER //
// ./src/store/store.js